export const winnersAndLosersSearchBy = [
	{ key: "winners", value: "Operators Starting" },
	{ key: "losers", value: "Operators going out of Business" },
];
